module.exports = __webpack_public_path__ + "img/secured-by-CardConnect.b2ab0434.png";